const THEME_COLOR = '##2f77b6';


export const theme = {
    button: {
        background: THEME_COLOR,
        on_hover_background: '#eee',
        on_hover_text: '#000'
    }
}